import componentSizes from "../../../constants/componentSizes";

export const DEFAULT_COUNTRY = "US";
export const DEFAULT_COUNTRY_CODE = "1";
export const PHONE_NUMBER_FIELD_SIZES = [
  componentSizes.SM,
  componentSizes.MD,
  componentSizes.LG
];
